export default __webpack_public_path__ + "static/media/managed-venues.en.76e91501.vtt";